<script>
import axios from '@/utils/api'
import FileSaver from 'file-saver'
import AppModalVisualizaPdf from '@/components/AppModalVisualizaPdf.vue'

export default {
  components: {
    AppModalVisualizaPdf
  },
  data () {
    return {
      base64: null
    }
  },
  props: {
    fotos: {
      type: Object
    }
  },
  methods: {
    visualizar (foto) {
      this.base64 = foto.base64
    },
    async baixar (foto) {
      const file = await axios({
        method: 'POST',
        url: `foto/download/ByPath`,
        data: { path: foto.path },
        responseType: 'blob',
        laoder: false
      })
      const pathSplit = foto.path.split('/')
      FileSaver.saveAs(file, pathSplit[pathSplit.length - 1])
    }
  }
}
</script>

<template>
  <div v-loading="fotos.loading" class="container-fotos">
    <AppModalVisualizaPdf v-if="base64" titulo="Foto" :base64="base64" :isImagem="true" :showFooter="false" @closeModal="() => base64 = null" />
    <div v-for="(foto, index) in fotos.srcList" :key="index" class="card-foto">
      <div class="display-foto">
        <el-image
          fit="scale-down"
          style="width: 200px; height: 115px"
          :src="foto.base64"
        />
      </div>
      <div class="acoes-foto">
        <div class="acao-button" @click="baixar(foto)">
          <button>
            <i class="fas fa-download"></i>
          </button>
        </div>
        <div class="acao-button" @click="visualizar(foto)">
          <button>
            <i class="material-icons">visibility</i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Galeria/components/GridFotos.vue